export default {
    /*baseURL: "http://localhost:8000/v1/",*/
    baseURL : "https://api.onlaine.com.br/v1/",
}